// packages/api/src/axios-client.ts
import axios from 'axios';
import { handle401 } from './handle401';

const baseURL = process.env.NEXT_PUBLIC_SSO_API_URL || 'https://app.atajoy.com/ssoapi';
export const axiosClient = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true
});
axiosClient.interceptors.request.use(
  (config) => {
    if (typeof window === 'undefined') {
    } else {
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.status === 401) {
      handle401()
      if (typeof window !== 'undefined') {
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosClient;